import React, { useState } from 'react';
import cn from 'classnames';
import style from "../common.module.scss"
import LocationIconNew from '../../../shared/icons/LocationIconNew';
import { numberToFinanceFormat } from '../../../../utils';
import {t} from "i18next";

const OrdersInfoBasic = ({ item, onOpen, userType = "", companyId = "" }) => {

    return (
        <div className={cn(style.basic_wrapper)}>
            <div className={style.basic_numbers}>
                <span className={style.basic_price}>{numberToFinanceFormat(userType === "Expeditor" && companyId !== item?.companyId ? item?.netPrice : item?.price)}〒</span>
                <div className={style.basic_lower_part}>
                    <div className={style.basic_distance}>
                        {numberToFinanceFormat(item?.distance)} {t ('analytics.distance_metric')}
                    </div>
                    <span className={style.basic_number}> №{item?.number}</span>
                </div>
            </div>
            <button className={style.basic_btn} onClick={onOpen}>
                <LocationIconNew /> { t ("orderInfo.orderHistory")}
            </button>
        </div>
    );
};

export default OrdersInfoBasic;